import { render, staticRenderFns } from "./Justbon.vue?vue&type=template&id=1cd0a098&scoped=true&"
import script from "./Justbon.vue?vue&type=script&lang=js&"
export * from "./Justbon.vue?vue&type=script&lang=js&"
import style0 from "./Justbon.vue?vue&type=style&index=0&id=1cd0a098&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd0a098",
  null
  
)

export default component.exports